import { api } from "@/api/client";
import type { EntityLookupValue } from "@/components/shared/EntityLookup";

export const COBRANCA_PATH = "instituicao/InstituicaoCobranca";

export interface Cobranca {
  id: number;
  instituicao: { codigo: string; nomeFantasia: string };
  dataEmissao: string;
  dataVencimento: string;
  valorCobranca: number;
  situacaoCobranca: "P" | "A" | "V" | string;
  seIgnorarCobranca: "S" | "N";
  metodoPagamento?: string | null;
}

export interface CobrancaFiltro {
  dataInicial?: string;
  dataFinal?: string;
  situacaoCobranca?: string;
  situacaoInstituicao?: string;
  metodoPagamento?: string;
  seIgnoradas: "S" | "N";
  instituicao?: EntityLookupValue;
  instituicaoId?: number;
}

export async function ignorarCobranca(id: number): Promise<void> {
  // Legado usa GET pra essa ação (não é REST-puro, mas é o contrato real do
  // gateway) — mantido idêntico.
  await api.get(`${COBRANCA_PATH}/Ignorar/${id}`);
}

// Usado só quando a rota chega com instituicaoId na URL
// (/Cobranca/Consulta/Instituicao/:id) — precisa pré-popular o
// <EntityLookup> com a instituição já conhecida pelo id, antes mesmo de o
// usuário abrir a busca. O backend expõe `descricao` na entidade Instituicao
// pelo mesmo motivo que a Fase 4 (EntityLookup) já assume: é o campo que
// toda tela de lookup usa pra exibição, não um detalhe exclusivo da busca.
export async function getInstituicaoLookup(id: number): Promise<EntityLookupValue> {
  const { data } = await api.get<EntityLookupValue>(`instituicao/Instituicao/${id}`);
  return data;
}
